/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticIconShelf,
  AnimaticIconShelf$inboundSchema,
} from "./animaticiconshelf.js";
import {
  AnimaticValueShelf,
  AnimaticValueShelf$inboundSchema,
} from "./animaticvalueshelf.js";

/**
 * The kind of the shelf. There are multiple types and we can continue to add more.
 */
export const AnimaticShelfKind = {
  Icon: "icon",
  Value: "value",
} as const;
/**
 * The kind of the shelf. There are multiple types and we can continue to add more.
 */
export type AnimaticShelfKind = OpenEnum<typeof AnimaticShelfKind>;

/**
 * Specifies details for a shelf that is displayed with an Animatic.
 */
export type AnimaticShelf = {
  /**
   * Specifies details for an icon shelf that is shown below an Animatic Card.
   */
  iconShelf?: AnimaticIconShelf | undefined;
  /**
   * The kind of the shelf. There are multiple types and we can continue to add more.
   */
  kind: AnimaticShelfKind;
  /**
   * The name of the shelf
   */
  name: string;
  /**
   * Optional title of the shelf
   */
  title?: string | undefined;
  /**
   * Specifies details for a value shelf that is shown below an Equipment Browser Item.
   */
  valueShelf?: AnimaticValueShelf | undefined;
};

/** @internal */
export const AnimaticShelfKind$inboundSchema: z.ZodType<
  AnimaticShelfKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticShelfKind);

/** @internal */
export const AnimaticShelf$inboundSchema: z.ZodType<
  AnimaticShelf,
  z.ZodTypeDef,
  unknown
> = z.object({
  icon_shelf: types.optional(AnimaticIconShelf$inboundSchema),
  kind: AnimaticShelfKind$inboundSchema,
  name: types.string(),
  title: types.optional(types.string()),
  value_shelf: types.optional(AnimaticValueShelf$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "icon_shelf": "iconShelf",
    "value_shelf": "valueShelf",
  });
});

export function animaticShelfFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticShelf, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticShelf$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticShelf' from JSON`,
  );
}
